import { render } from "./NasTeam.vue?vue&type=template&id=6e85f8ec"
import script from "./NasTeam.vue?vue&type=script&lang=js"
export * from "./NasTeam.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__